import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../data/mock';
import { Shield, Zap, Users, TrendingUp } from 'lucide-react';

const StatCard = ({ stat, index, isVisible }) => {
  const [count, setCount] = useState(0);
  const numericValue = parseInt(stat.value.replace(/[^0-9]/g, '')) || 0;
  
  useEffect(() => {
    if (!isVisible || numericValue === 0) return;
    
    const duration = 1500;
    const steps = 40;
    const increment = numericValue / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= numericValue) {
        setCount(numericValue);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    
    return () => clearInterval(timer);
  }, [isVisible, numericValue]);

  const icons = [TrendingUp, Users, Shield, Zap];
  const Icon = icons[index % icons.length];

  const formatValue = () => {
    if (stat.value.includes('£')) return `£${count}B+`;
    if (stat.value.includes('%')) return `${count}%`;
    if (stat.value.includes('+')) return `${count.toLocaleString()}+`;
    return count.toLocaleString();
  };

  return (
    <div
      className={`p-4 md:p-5 bg-[#004048]/20 border border-[#59d862]/20 rounded-2xl text-center transition-all duration-500 hover:border-[#59d862]/40 hover:bg-[#004048]/30 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <Icon className="w-6 h-6 text-[#59d862] mx-auto mb-2" />
      <div className="text-xl md:text-2xl font-bold text-[#59d862] mb-1 heading">{formatValue()}</div>
      <div className="text-white/55 text-xs md:text-sm">{stat.label}</div>
    </div>
  );
};

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-8 md:py-10 bg-black overflow-hidden">
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {stats.map((stat, index) => (
            <StatCard key={index} stat={stat} index={index} isVisible={isVisible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
